<template>
    <div>
        <AppHeader
            :breadcrumbs="breadcrumbs"
        >
            <div class="header-actions">
                <DThemeToggle />
                <DTrainingsCourse
                    v-if="trainingsCourseLink !== null"
                    :trainings-course-link="trainingsCourseLink"
                />
                <DUserDropdown
                    v-if="user.name"
                    :user-name="user.name"
                    :user-id="user.id"
                />
                <DChangeLanguage
                    v-if="shouldDisplayChangeLanguage"
                />
                <DMailInterceptorLink
                    v-if="isNotProductionEnvironment"
                    :mail-catcher-url="mailCatcherUrl"
                />
                <DTenantDropdown
                    :tenant="tenant"
                    :tenants="tenants"
                />
            </div>
        </AppHeader>
    </div>
</template>

<script>
import AppHeader from '~@/Components/App/Header/AppHeader'
import DTenantDropdown from '~@/Components/App/Header/DTenantDropdown'
import DUserDropdown from '~@/Components/App/Header/DUserDropdown'
import DChangeLanguage from '~@/Components/App/Header/DChangeLanguage'
import DMailInterceptorLink from '~@/Components/App/Header/DMailInterceptorLink'
import DTrainingsCourse from '~@/Components/App/Header/DTrainingsCourse'
import DThemeToggle from '~@/Components/App/Header/DThemeToggle'

export default {
    name: 'Header',
    components: {
        DMailInterceptorLink,
        DChangeLanguage,
        AppHeader,
        DTenantDropdown,
        DUserDropdown,
        DTrainingsCourse,
        DThemeToggle
    },
    props: {
        breadcrumbs: {
            type: Array,
            default: () => { return [] }
        }
    },
    computed: {
        user () {
            return this.$page.props.auth.user
        },
        tenant () {
            return this.$page.props.tenant
        },
        tenants () {
            return this.$page.props.tenants
        },
        shouldDisplayChangeLanguage () {
            return this.$page.props.shouldDisplayChangeLanguage
        },
        isNotProductionEnvironment () {
            return !this.$page.props.isProductionEnvironment
        },
        mailCatcherUrl () {
            return this.$page.props.mailCatcherUrl
        },
        trainingsCourseLink () {
            return this.$page.props.tenantSettings?.trainings_course_link ?? null
        }
    }
}
</script>

<style lang="scss" scoped>
.header-actions {
    display: flex;
    align-items: center;
    gap: 10px;
}
</style>
